<template>
    <div class="savings-page">
        <SavingsContent />
        <SavingsCTA />
    </div>
</template>

<script>

import headers from "../models/headers";
import SavingsCTA from "../components/savings/SavingsCTA.vue";
import SavingsContent from "../components/savings/SavingsContent.vue";

export default {

    components: {
        SavingsContent,
        SavingsCTA
    },
    metaInfo: headers.savingsPage(),
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>
